import React, { useContext } from 'react';
import { FilterContext, FilterPanel, activeChips } from './FilterShelf';

export const CHART_COLORS = ['#003c71', '#0067a0', '#00a7b5', '#13b5d2', '#4a6475', '#7a9cb0', '#b8c9d8'];

// ── Formatters ─────────────────────────────────────────────────────────────

export function fmtCount(n) {
  return Math.round(n).toLocaleString('en-US');
}

export function fmtDollar(n) {
  const abs = Math.abs(n);
  const formatted = abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (n < 0 ? '-$' : '$') + formatted;
}

export function fmtMillions(n) {
  const abs = Math.abs(n);
  const prefix = n < 0 ? '-$' : '$';
  if (abs >= 1_000_000_000) return prefix + (abs / 1_000_000_000).toFixed(1) + 'B';
  if (abs >= 1_000_000)     return prefix + (abs / 1_000_000).toFixed(1) + 'M';
  if (abs >= 1_000)         return prefix + (abs / 1_000).toFixed(1) + 'K';
  return prefix + abs.toFixed(0);
}

export function fmtPct(n, decimals = 1) {
  return n.toFixed(decimals) + '%';
}

// ── Components ─────────────────────────────────────────────────────────────

export function PageHeader({ title, memberCount, detail }) {
  const members     = memberCount != null ? fmtCount(memberCount) : '—';
  const ctx         = useContext(FilterContext);
  const activeCount = ctx ? activeChips(ctx.filters).length : 0;
  return (
    <div>
      <div className="dash-page-header">
        <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '0.6rem' }}>
          <span className="dash-page-title">{title}</span>
          <span className="dash-page-subtitle">Q1 2026  ·  {members} Members  ·  All Markets  ·  Commercial</span>
          {detail && <span className="dash-page-subtitle" style={{ width: '100%' }}>{detail}</span>}
        </div>
        {ctx && (
          <button type="button" className="filter-shelf-toggle" onClick={() => ctx.setOpen(o => !o)}>
            ⚙ Filters{activeCount > 0 ? ` (${activeCount})` : ''} {ctx.open ? '▴' : '▾'}
          </button>
        )}
      </div>
      {ctx?.open && <FilterPanel />}
    </div>
  );
}

const _STAT_FMT = { dollar: fmtDollar, millions: fmtMillions, pct: fmtPct, count: fmtCount };

export function StatCard({ value, label, delta, up, fmt }) {
  const displayValue = fmt && _STAT_FMT[fmt] ? _STAT_FMT[fmt](value) : value;
  const displayDelta = typeof delta === 'number' ? fmtDollar(delta) : delta;
  return (
    <div className="dash-stat-card">
      <div className="dash-stat-value">{displayValue}</div>
      <div className="dash-stat-label">{label}</div>
      {displayDelta && <div className={`dash-stat-delta ${up ? 'pos' : 'neg'}`}>{displayDelta}</div>}
    </div>
  );
}

export function TierBadge({ tier }) {
  const map = {
    'HIGH': 'tier-high', 'MED': 'tier-med', 'LOW': 'tier-low',
    'TIER 1': 'tier-1', 'PREFERRED': 'tier-1',
    'TIER 2': 'tier-2', 'STANDARD': 'tier-2',
    'TIER 3': 'tier-3', 'REVIEW': 'tier-3',
  };
  return <span className={`dash-tier-badge ${map[tier] ?? ''}`}>{tier}</span>;
}

export function SubTabBar({ tabs, active, onChange }) {
  return (
    <div className="dash-sub-tabs-bar">
      {tabs.map(t => (
        <button
          key={t.key}
          className={`dash-sub-tab-btn${active === t.key ? ' active' : ''}`}
          onClick={() => onChange(t.key)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
